import React from "react"

export function NoSettings() {
  return <div className="italic">There are no settings for this element.</div>
}
